import { Utils } from "../clases/rezultatai/Utils";

const ANSWER_SCORES = {
    'Sutikčiau': 10,
    'Nesutikčiau': 0,
    'Nežinau': 5
};

export class ScoringService {
    static convertAnswerToScore(value) {
        if (!value) return 0;
        
        // Handle string answers like "Sutikčiau"
        if (typeof value === 'string') {
            if (ANSWER_SCORES.hasOwnProperty(value)) {
                return ANSWER_SCORES[value];
            }
            return Utils.isNumber(value) ? parseFloat(value) : 0;
        }
        
        return 0;
    }

    static calculateScore(value) {
        if (!value) return 0;
        
        // Jei ateina tekstinis atsakymas (pvz "Sutikčiau"), grąžiname 1
        if (typeof value === 'string' && !Utils.isNumber(value)) {
            return 1;
        }
        
        // Jei ateina skaitinis atsakymas
        if (typeof value === 'string' && Utils.isNumber(value)) {
            return parseFloat(value);
        }
        
        // Jei ateina objektas su keliais atsakymais
        if (typeof value === 'object' && value !== null) {
            const scores = Object.values(value).map(subValue => {
                if (typeof subValue === 'string' && !Utils.isNumber(subValue)) {
                    return 1; // Tekstinis atsakymas
                }
                return Utils.isNumber(subValue) ? parseFloat(subValue) : 0;
            });
            
            if (!scores.length) return 0;
            return scores.reduce((sum, score) => sum + score, 0) / scores.length;
        }
        
        return 0;
    }

    static calculateAverageScore(answers = [], questionName) {
        if (!answers.length) return 0;
        
        const scores = answers
            .map(answer => this.calculateScore(answer[questionName]))
            .filter(score => !isNaN(score));
            
        if (!scores.length) return 0;
        return Utils.round(scores.reduce((sum, score) => sum + score, 0) / scores.length);
    }

    static calculateTotalScore(answers = {}) {
        const scores = Object.values(answers)
            .filter(value => typeof value === 'number' && !isNaN(value))
            .map(value => parseFloat(value));
            
        if (!scores.length) return 0;
        return scores.reduce((sum, score) => sum + score, 0) / scores.length;
    }

    static calculatePercentageScore(score) {
        return (score / 10) * 100;
    }
}
